<template>
    <v-container>
        <v-row>
            <v-col lg="6">
                <h1 class="title font-weight-light mb-5 black--text">
                    <v-icon left color="black">mdi-view-grid-plus</v-icon>
                    Widget Ekle
                    <v-divider class="mt-2"></v-divider>
                </h1>
                <v-card class="py-5 px-5">
                <v-text-field
                class="font-weight-light"
                prepend-icon="mdi-focus-field"
                label="Widget Adı"
                v-model="widgetName"
                ></v-text-field>
                <v-text-field
                class="font-weight-light"
                prepend-icon="mdi-focus-field"
                label="Widget Sistem Adı (Opsiyonel)"
                v-model="widgetSysName"
                ></v-text-field>
                <v-row :key="key" v-for="(field, key) in fields" align="center" class="elevation-2 rounded mb-5">
                    <v-col cols="5">
                        <v-select
                        prepend-icon="mdi-focus-field-horizontal"
                        class="font-weight-light"
                        :items="widgetFieldTypes"
                        label="Type"
                        v-model="field.type"
                        ></v-select>
                    </v-col>
                    <v-col>
                        <v-text-field
                        prepend-icon="mdi-focus-field-horizontal"
                        class="font-weight-light"
                        label="Takma Ad"
                        v-model="field.name"
                        hint="Örn: icon"
                        persistent-hint
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-tooltip right color="black">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-on="on" v-bind="attrs" small color="red darken-2" icon outlined class="d-block mx-auto font-weight-light" dark @click="deleteField(key)">
                                    <v-icon small>mdi-delete-forever</v-icon>
                                </v-btn>
                            </template>
                            <span>Kaldır</span>
                        </v-tooltip>
                    </v-col>

                    <v-col cols="12" v-if="field.type === 'autocomplete'">
                        <v-select
                        class="font-weight-light"
                        :items="autoCompletes"
                        label="Autocomplete Verisi"
                        v-model="field.data"
                        hint="Otomatik tamamlamak için çekilecek verisini seçin"
                        persistent-hint
                        ></v-select>
                    </v-col>

                    <v-col cols="12" v-if="field.type === 'select'">
                        <v-select
                        class="font-weight-light"
                        :items="autoSelects"
                        label="Select Verisi"
                        v-model="field.data"
                        hint="Çekilecek select verisini seçin"
                        persistent-hint
                        ></v-select>
                    </v-col>

                </v-row>

                <div class="d-flex justify-end">
                    <v-btn small color="blue" dark class="mr-3" @click="addField">
                        <v-icon left small>mdi-plus-box-multiple</v-icon>
                        Alan Ekle
                    </v-btn>
                    <v-btn small color="green" dark @click="addWidget">
                        <v-icon left small>mdi-plus-circle</v-icon>
                        Widget'ı Ekle
                    </v-btn>
                </div>
                </v-card>
            </v-col>
            <v-col lg="6">
                    <h1 class="title font-weight-light mb-5 black--text">
                        <v-icon left color="black">mdi-widgets-outline</v-icon>
                        Widget Listesi <span class="text-body-2 font-weight-light">(Öntanımlı)</span>
                        <v-divider class="mt-2"></v-divider>
                    </h1>
                    <v-expansion-panels class="widget-item-group item-group mb-2" :key="key" v-for="(widget, key) in widgets">
                            <v-expansion-panel class="widget-item">
                                <v-expansion-panel-header>
                                    <template  v-slot:default="{ open }">
                                        <v-row no-gutters>
                                            <v-col 
                                            cols="4"
                                            class="d-flex align-center"
                                            >
                                                <v-icon size="20" class="widgets-icon" left>mdi-drag-variant</v-icon>
                                                {{ widget.name }}
                                            </v-col>
                                            <v-col
                                            cols="4"
                                            class="d-flex align-center text--secondary"
                                            >
                                            <v-fade-transition leave-absolute>
                                                <div
                                                v-if="open"
                                                key="0"
                                                class="text-body-2"
                                                >
                                                "{{ widget.widget }}"
                                                </div>
                                            </v-fade-transition>
                                            </v-col>
                                        </v-row>
                                    </template>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-list>
                                        <v-list-item-subtitle class="text-caption font-weight-medium mb-2">
                                            Aldığı değerler dizisi
                                            <v-divider></v-divider>
                                        </v-list-item-subtitle>
                                        <v-row>
                                            <v-col :key="key" v-for="(field, key) in widget.fields">
                                                <v-list-item class="px-0">
                                                    <v-list-item-content class="py-0">
                                                        <v-list-item-title>
                                                            <v-icon left>mdi-focus-field-horizontal</v-icon>
                                                            <span class="text-overline">{{ field.name }}</span> <span class="text-caption">({{field.type}})</span>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-col>
                                        </v-row>
                                    </v-list>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'DevWidgets',
    data() {
        return {
            widgetName: '',
            widgetSysName: '',
            fields: [
                {
                    type: '',
                    name: ''
                }
            ],
            widgetFieldTypes: [{
                text: 'text',
                value: 'text'
            },
            {
                text: 'autocomplete',
                value: 'autocomplete',
                data: '',
            },
            {
                text: 'select',
                value: 'select',
                data: '',
            }
            ],
            autoCompletes: [
                // {
                //     text: 'System Views',
                //     value: 'systemViews'
                // }
            ],
            autoSelects: [
                {
                    text: 'System Views',
                    value: 'systemViews'
                }
            ],
            
        }
    },
    computed: {
        ...mapGetters({
            widgets: 'Widget/Widgets/getWidgetsList'
        })
    },
    methods: {
        /**
         * Sisteme Widget Eklemesi Yap
         */
        addWidget() {
            const {widgetName, widgetSysName, fields} = this
            this.$store.dispatch('Widget/Widgets/addWidget', {widgetName, widgetSysName, fields}).then(res => {
                if (res.status === 200) {
                    this.$snotify.success('Widget başarıyla eklenmiştir', this.$t('PANEL.NOTIFY.SUCCESS'));
                } else {
                    this.$snotify.error(res.data.errMessage, 'Hata!');
                }
            })
        },
        addField() {
            this.fields.push({name:'', type: ''})
        },
        deleteField(key) {
            this.fields.splice(key, 1);
        }
    },
    created() {
        /**
         *  Kullanılabilir Widgets Listesini Getir
         */
        this.$store.dispatch('Widget/Widgets/getWidgets')
    }
}
</script>